import React, { useEffect, useState } from "react";
import ProviderSettingsModal from "./ProviderSettingsModal";

const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

function ProviderCategoryModal({
  show,
  isEditing = false,
  initialForm = { name: "", description: "", status: "active" },
  saving = false,
  errors = {},
  onClose,
  onSubmit,
  onFieldChange,
}) {
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (show) {
      setForm(initialForm);
    }
  }, [show, initialForm]);

  const handleFieldChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    onFieldChange?.(field, value);
  };

  const handleSubmit = () => {
    onSubmit?.(form);
  };

  return (
    <ProviderSettingsModal
      show={show}
      title={isEditing ? "Edit Category" : "Add Category"}
      onClose={onClose}
      onSubmit={handleSubmit}
      submitLabel={isEditing ? "Update" : "Add"}
      saving={saving}
    >
      <div className="mb-4">
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          autoFocus
          placeholder="e.g. University, College, Language School"
          value={form.name}
          onChange={(event) => handleFieldChange("name", event.target.value)}
          className={`${inputClass} ${
            errors.name ? "border-red-400 focus:border-red-400" : ""
          }`}
        />
        {errors.name ? (
          <span className="mt-1.5 block text-xs text-red-500">{errors.name}</span>
        ) : null}
      </div>

      <div className="mb-4">
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Description
        </label>
        <textarea
          rows={3}
          placeholder="Optional description for this category"
          value={form.description}
          onChange={(event) => handleFieldChange("description", event.target.value)}
          className={`${inputClass} resize-y`}
        />
      </div>

      <div>
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Status
        </label>
        <select
          value={form.status}
          onChange={(event) => handleFieldChange("status", event.target.value)}
          className={inputClass}
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
    </ProviderSettingsModal>
  );
}

export default ProviderCategoryModal;
